import React from "react"
import type { TicketPurchaseWithPurchaser } from "../../requests/ticketPurchases"
import { TicketRowMobile } from "./TicketRowMobile"

interface TicketsViewMobileProps {
  tickets: TicketPurchaseWithPurchaser[]
  expandedTickets: Set<number>
  onToggleExpanded: (ticketId: number) => void
  onRedeem: (ticketId: number) => void
  onUnredeem: (ticketId: number) => void
  onDelete: (ticketId: number) => void
  onCancelRefund: (ticket: TicketPurchaseWithPurchaser) => void
  isRedeemLoading: boolean
  isUnredeemLoading: boolean
  isDeleteLoading: boolean
  isCancelRefundLoading: boolean
}

export const TicketsViewMobile: React.FC<TicketsViewMobileProps> = ({
  tickets,
  expandedTickets,
  onToggleExpanded,
  onRedeem,
  onUnredeem,
  onDelete,
  onCancelRefund,
  isRedeemLoading,
  isUnredeemLoading,
  isDeleteLoading,
  isCancelRefundLoading,
}) => (
  <div className="xl:hidden space-y-4">
    {tickets.map((ticket) => (
      <TicketRowMobile
        key={ticket.id}
        ticket={ticket}
        isExpanded={expandedTickets.has(ticket.id)}
        onToggleExpanded={onToggleExpanded}
        onRedeem={onRedeem}
        onUnredeem={onUnredeem}
        onDelete={onDelete}
        onCancelRefund={onCancelRefund}
        isRedeemLoading={isRedeemLoading}
        isUnredeemLoading={isUnredeemLoading}
        isDeleteLoading={isDeleteLoading}
        isCancelRefundLoading={isCancelRefundLoading}
      />
    ))}
  </div>
)
